export default "__VITE_ASSET__B38C5GMg__"